import { render, staticRenderFns } from "./CourseColumnMapper.vue?vue&type=template&id=656010c4&scoped=true"
import script from "./CourseColumnMapper.vue?vue&type=script&lang=js"
export * from "./CourseColumnMapper.vue?vue&type=script&lang=js"
import style0 from "./CourseColumnMapper.vue?vue&type=style&index=0&id=656010c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656010c4",
  null
  
)

export default component.exports